import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIClickable from 'UIComponents/button/UIClickable';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIImage from 'UIComponents/image/UIImage';
import { Fragment } from 'react';
import { ExpandableSectionLabel, ExpandableTableContent, ExpandTableButtonContainer } from './SuiteFeatureTableComponents';
import UIButton from 'UIComponents/button/UIButton';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { getProductLineIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import { getFeaturesAtProductLevel, getEnrolledProductLineFeatureAccessLevels } from '../CommerceFeatureTableConfig';
import CommerceFeatureTableRow from '../CommerceFeatureTableRow';
export const CommerceHubFeatureContent = ({
  levels,
  handleExpandSectionChange,
  isSectionExpanded,
  handleExpandFeatureTableChange,
  isFeatureTableExpanded
}) => {
  const productIcons = getProductLineIcons();
  const accessLevels = getEnrolledProductLineFeatureAccessLevels(COMMERCE);
  const features = getFeaturesAtProductLevel(COMMERCE, [...levels]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ExpandableSectionLabel, {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: levels.size + 1,
          children: /*#__PURE__*/_jsx(UIClickable, {
            onClick: () => handleExpandSectionChange(COMMERCE),
            "aria-expanded": isSectionExpanded[COMMERCE] ? 'true' : 'false',
            "aria-controls": `suite-feature-table-${COMMERCE}-section`,
            children: /*#__PURE__*/_jsxs("div", {
              className: "display-flex align-center",
              children: [/*#__PURE__*/_jsx(UIImage, {
                src: productIcons[COMMERCE],
                width: "24",
                className: "m-right-3"
              }), /*#__PURE__*/_jsx("strong", {
                children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                  message: `suiteFeatureTable.section.title`,
                  options: {
                    product: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: `productLine.${COMMERCE}`
                    })
                  }
                })
              })]
            })
          })
        })
      })
    }), /*#__PURE__*/_jsx(ExpandableTableContent, {
      id: `suite-feature-table-${COMMERCE}-section`,
      isSectionExpanded: isSectionExpanded[COMMERCE],
      isFeatureTableExpanded: isFeatureTableExpanded[COMMERCE],
      children: features.map(feature => {
        return /*#__PURE__*/_jsx(CommerceFeatureTableRow, {
          productLevels: [...levels],
          accessLevels: accessLevels,
          feature: feature,
          isSuite: true
        }, feature.shortName);
      })
    }), isSectionExpanded[COMMERCE] && /*#__PURE__*/_jsx(ExpandTableButtonContainer, {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: levels.size + 1,
          className: "display-flex align-center",
          children: /*#__PURE__*/_jsxs(UIButton, {
            use: "transparent",
            onClick: () => {
              handleExpandFeatureTableChange(COMMERCE);
            },
            "aria-expanded": isSectionExpanded[COMMERCE] ? 'true' : 'false',
            className: "p-left-8",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: isFeatureTableExpanded[COMMERCE] ? `suiteFeatureTable.ebx633Collapse` : `suiteFeatureTable.ebx633Expand`
            }), /*#__PURE__*/_jsx(UIIcon, {
              name: isFeatureTableExpanded[COMMERCE] ? 'upCarat' : 'downCarat',
              color: EERIE
            })]
          })
        })
      })
    })]
  }, COMMERCE);
};